/**
 * Browser-side Better Auth client. Same-origin, so no explicit baseURL.
 * The generic-OAuth client plugin exposes `authClient.signIn.oauth2(...)` for
 * the Keycloak login.
 */
import { createAuthClient } from "better-auth/react";
import { genericOAuthClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  plugins: [genericOAuthClient()],
});

export const { signIn, signOut, useSession } = authClient;
